import React from 'react';
import { IconProps } from '.';

const SvgFilter = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M13.25 12.645c0-.445.17-.874.475-1.198l6.292-6.699H3.983l6.292 6.699.109.126c.236.305.366.682.366 1.072v7.391l2.5-1.25v-6.141Zm1.5 7.07-5.5 2.75v-9.82a.251.251 0 0 0-.04-.134l-.028-.038-6.687-7.12c-.75-.797-.184-2.104.91-2.105h17.189c1.06 0 1.624 1.227.977 2.03l-.066.076-6.688 7.119a.252.252 0 0 0-.067.172v7.07Z'
      />
    </svg>
  );
};

export default SvgFilter;
